import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'material-ui';
import ClassNames from 'classnames';
import ChevronLeftIcon from '../../icons/ChevronLeftIcon';

const PrevStep = ({ className, label, prevStep, step, onClick, mobile }) =>
  mobile ? (
    <Button
      className={ClassNames(className, { disabled: !step || !step.enabled })}
      raised
      disabled={!step || !step.enabled}
      onClick={() => onClick(step.id.toLowerCase())}
    >
      <ChevronLeftIcon className={ClassNames(className, { disabled: !step || !step.enabled })} />
      {label ? <span className={`${className}-main-label`}>{label}</span> : null}
      {/* {prevStep ? <span className={`${className}-title-label`}>{prevStep}</span> : null} */}
    </Button>
  ) : (
    <a
      // disabled={!step.enabled}
      disabled
      onClick={() => onClick(step.id.toLowerCase())}
      className={ClassNames(className, { disabled: !step || !step.enabled })}
    >
      {label}
    </a>
  );

PrevStep.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  prevStep: PropTypes.string,
  step: PropTypes.object,
  mobile: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PrevStep;



// WEBPACK FOOTER //
// ./src/components/navigation/PrevStep.js